export default __webpack_public_path__ + "static/damon-flores-7b53cdc511383843129a962cfbae7250.png";